import { LoadableLazy } from '@confluence/loadable';

export const WhiteboardGAModalManager = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-WhiteboardGAModalManager" */ './WhiteboardGAModalManager'
			)
		).WhiteboardGAModalManager,
});

export const VersionHistoryModalManager = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-VersionHistoryModalManager" */ './VersionHistory/VersionHistoryModalManager'
			)
		).VersionHistoryModalManager,
});

export { VersionHistoryOnboardingSpotlight } from './VersionHistory/VersionHistoryOnboardingSpotlight';
